import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Icon } from '@sm360/ui-library'

import { VehicleCardContext } from '../../../../configs/vehicle-card-view/state.manager'
import formatNumber from '../../../../utils/format-number.utils'

const TOTAL_REBATES = 'total_rebates'

const VehicleRebates = ({ priceRounding, extraClasses, rebateValue }) => {
    const {
        state: {
            vehicle: { paymentOptions },
            XMSConfig: { taggingConfigurations },
        },
    } = React.useContext(VehicleCardContext)

    const baseClass = 'vc-vehicleRebates'
    const classNames = clsx(baseClass, extraClasses)

    const rebatesData = taggingConfigurations && taggingConfigurations?.find((config) => config.code === TOTAL_REBATES)
    const { backgroundColor, fontColor, picto } = rebatesData || {}
    const rebate = rebateValue || paymentOptions?.bestIncentives?.total || 0
    if (!rebatesData || rebate <= 0) return null

    return (
        <div className={classNames} style={{ backgroundColor }}>
            <Icon name={`icon-${picto || 'rebate-round'}`} className={`${baseClass}__icon`} />
            <span className={`${baseClass}__infos`} style={{ color: fontColor }}>
                {`${rebatesData?.label} ${formatNumber(rebate, priceRounding)}`}
            </span>
        </div>
    )
}

VehicleRebates.propTypes = {
    /** Rebate Value */
    rebateValue: PropTypes.number,
    /** Extra classes */
    extraClasses: PropTypes.string,
    /** Rounding option for prices */
    priceRounding: PropTypes.string,
}

VehicleRebates.defaultProps = {
    extraClasses: '',
    priceRounding: 'ROUND_UP',
}

export default VehicleRebates
